export const alphabet = (() => {
    const upperCasedLetters = [ 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L',
        'M', 'N', 'O', 'P', 'Q', 'R',  'S', 'T', 'U', 'V', 'W', 'X',
        'Y', 'Z' ]
    const lowerCasedLetters = upperCasedLetters.map(item => item.toLowerCase());

    return [...upperCasedLetters, ...lowerCasedLetters]
})()